import Vue from 'vue'
import Router from 'vue-router'
import {getCookie} from "../assets/common/js/config";

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: getCookie('wxmalltype')==0?'/profile':'activity'
    },
    {
      path: '/login',
      name: '',
      component: () => import(/* webpackChunkName: "icon" */ '../components/login/login.vue'),
      meta: {title: '杏林明师管理系统' },
    },
    {
      path: '/activity',
      component: () => import(/* webpackChunkName: "icon" */ '../components/activity/activity.vue'),
      meta: {
        title: '统计',
        keepAlive: true
      },
      children: [
        {
          path: '',
          name: '',
          component: () => import(/* webpackChunkName: "icon" */ '../components/activity/index.vue'),
          meta: {
            title: '其他',
            keepAlive: true
          },
        },{
          path: 'detail',
          name: '',
          component:() => import(/* webpackChunkName: "icon" */ '../components/activity/detail.vue'),
          meta: {
            title: '活动统计详情'
          },
        },]
    },
    {
      path: '/deal',
      component: () => import(/* webpackChunkName: "icon" */ '../components/deal/deal.vue'),
      meta: {
        title: '商品统计',
        keepAlive: true
      },
      children: [
        {
          path: '',
          name: '',
          component: () => import(/* webpackChunkName: "icon" */ '../components/deal/index.vue'),
          meta: {
            title: '交易统计',
            keepAlive: true
          },
        },{
          path: 'detail',
          name: '',
          component:() => import(/* webpackChunkName: "icon" */ '../components/deal/detail.vue'),
          meta: {
            title: '课程分成构成'
          },
        },{
          path: 'typedetail',
          name: '',
          component:() => import(/* webpackChunkName: "icon" */ '../components/deal/typedetail.vue'),
          meta: {
            title: '推广类型'
          },
        },{
          path: 'saledetail',
          name: '',
          component:() => import(/* webpackChunkName: "icon" */ '../components/deal/saledetail.vue'),
          meta: {
            title: '销售人员构成'
          },
        }]
    },
    {
      path: '/goods',
      component: () => import(/* webpackChunkName: "icon" */ '../components/goods/goods.vue'),
      meta: {
        title: '商品统计',
        keepAlive: true
      },
      children: [
        {
          path: '',
          name: '',
          component: () => import(/* webpackChunkName: "icon" */ '../components/goods/index.vue'),
          meta: {
            title: '商品统计',
            keepAlive: false
          },
        },{
          path: 'detail',
          name: '',
          component:() => import(/* webpackChunkName: "icon" */ '../components/goods/detail.vue'),
          meta: {
            title: '商品详情'
          },
        },]
    },
    {
      path: '/profile',
      component: () => import(/* webpackChunkName: "icon" */ '../components/profile/profile.vue'),
      meta: {
        title: '数据概况统计',
        keepAlive: true
      },
      children: [
        {
          path: '',
          name: '',
          component: () => import(/* webpackChunkName: "icon" */ '../components/profile/index.vue'),
          meta: {
            title: '数据概况统计',
            keepAlive: true
          },
        },]
    },
    {
      path: '/user',
      component:() => import(/* webpackChunkName: "icon" */ '../components/user/user.vue'),
      meta: {
        title: '用户统计',
        keepAlive: true
      },
      children: [
        {
          path: '',
          name: '',
          component:() => import(/* webpackChunkName: "icon" */ '../components/user/index.vue'),
          meta: {
            title: '用户统计',
            keepAlive: true
          },
        },
        {
          path: 'newindex',
          name: '',
          component:() => import(/* webpackChunkName: "icon" */ '../components/user/newindex.vue'),
          meta: {
            title: '用户统计',
            keepAlive: true
          },
        },
        {
          path: 'newdetail',
          name: '',
          component:() => import(/* webpackChunkName: "icon" */ '../components/user/newdetail.vue'),
          meta: {
            title: '用户详情',
            keepAlive: false
          },
        },
        {
          path: 'channeldetail',
          name: '',
          component:() => import(/* webpackChunkName: "icon" */ '../components/user/channeldetail.vue'),
          meta: {
            title: '用户详情',
            keepAlive: false
          },
        },
        {
          path: 'ambassadordetail',
          name: '',
          component:() => import(/* webpackChunkName: "icon" */ '../components/user/ambassadordetail.vue'),
          meta: {
            title: '用户详情',
            keepAlive: false
          },
        },
        {
          path: 'detail',
          name: '',
          component:() => import(/* webpackChunkName: "icon" */ '../components/user/detail.vue'),
          meta: {
            title: '用户详情'
          },
        },
        {
          path: 'region',
          name: '',
          component:() => import(/* webpackChunkName: "icon" */ '../components/user/region.vue'),
          meta: {
            title: '付费学员分布',
            keepAlive: false
          },
        },
      ]
    },
    {
      path: '/trading',
      name: '',
      component:() => import(/* webpackChunkName: "icon" */ '../components/trading/trading.vue'),
      meta: {
        title: '交易统计',
        keepAlive: true
      },
      children: [
        {
          path: '',
          name: '',
          component:() => import(/* webpackChunkName: "icon" */ '../components/trading/index.vue'),
          meta: {
            title: '交易统计',
            keepAlive: true
          },
        },
        {
          path: 'detail',
          name: '',
          component:() => import(/* webpackChunkName: "icon" */ '../components/trading/detail.vue'),
          meta: {
            title: '交易详情'
          },
        },
        {
          path: 'acttrading',
          name: '',
          component:() => import(/* webpackChunkName: "icon" */ '../components/trading/acttrading.vue'),
          meta: {
            title: '统计'
          },
        },
      ]
    },
    {
      path: '/ranking',
      component:() => import(/* webpackChunkName: "icon" */ '../components/ranking/ranking.vue'),
      meta: {
        title: '排行',
        keepAlive: true
      },
      children: [
        {
          path: '',
          name: '',
          component:() => import(/* webpackChunkName: "icon" */ '../components/ranking/index.vue'),
          meta: {
            title: '销售排行',
            keepAlive: true
          },
        },{
          path: 'newindex',
          name: '',
          component:() => import(/* webpackChunkName: "icon" */ '../components/ranking/newindex.vue'),
          meta: {
            title: '销售排行',
            keepAlive: true
          },
        },
      ]
    },
    {
      path: '/money',
      name: '',
      component:() => import(/* webpackChunkName: "icon" */ '../components/money/money.vue'),
      meta: {
        title: '资金统计',
        keepAlive: true
      },
      children: [
        {
          path: '',
          name: '',
          component: () => import(/* webpackChunkName: "icon" */ '../components/money/index.vue'),
          meta: {
            title: '资金统计',
            keepAlive: true
          },
        },
        {
          path: 'detail',
          name: '',
          component:() => import(/* webpackChunkName: "icon" */ '../components/money/detail.vue'),
          meta: {
            title: '资金详情',
            keepAlive: false
          },
        },
      ]
    },
    {
      path: '/course',
      name: '',
      component:() => import(/* webpackChunkName: "icon" */ '../components/course/course.vue'),
      meta: {
        title: '课程统计',
        keepAlive: true
      },
      children: [
        {
          path: '',
          name: '',
          component: () => import(/* webpackChunkName: "icon" */ '../components/course/index.vue'),
          meta: {
            title: '课程统计',
            keepAlive: true
          },
        },
        {
          path: 'detail',
          name: '',
          component:() => import(/* webpackChunkName: "icon" */ '../components/course/detail.vue'),
          meta: {
            title: '课程详情',
            keepAlive: false
          },
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js